export default __webpack_public_path__ + "static/media/Lock_Locked.9d05a115.svg";